import {
 getTableFailure as settingsGetTableFailure,
 createItemSuccess as settingsCreateItemSuccess,
 createItemFailure as settingsCreateItemFailure,
 updateItemSuccess as settingsUpdateItemSuccess,
 updateItemFailure as settingsUpdateItemFailure,
 deleteItemSuccess as settingsDeleteItemSuccess,
 deleteItemFailure as settingsDeleteItemFailure,
} from '../settings/settingsSlice';
import {
 getTableFailure as weightingsGetTableFailure,
 createItemSuccess as weightingsCreateItemSuccess,
 createItemFailure as weightingsCreateItemFailure,
 updateItemSuccess as weightingsUpdateItemSuccess,
 updateItemFailure as weightingsUpdateItemFailure,
 deleteItemSuccess as weightingsDeleteItemSuccess,
 deleteItemFailure as weightingsDeleteItemFailure,
} from '../weightings/weightingsSlice';
import {
 getTableFailure as resultsGetTableFailure,
 createItemSuccess as resultsCreateItemSuccess,
 createItemFailure as resultsCreateItemFailure,
 updateItemSuccess as resultsUpdateItemSuccess,
 updateItemFailure as resultsUpdateItemFailure,
 deleteItemSuccess as resultsDeleteItemSuccess,
 deleteItemFailure as resultsDeleteItemFailure,
 approveResultSuccess,
 approveResultFailure,
} from '../results/resultsSlice';
import {
 getClientConfigurationsFailure,
 getClientConfigurationsSuccess,
} from '../clientConfiguration/clientConfigurationSlice';
import { identityLoginFailure } from '../identity/identitySlice';
import { sendIVAZFailure, sendIVAZSuccess } from '../ivaz/ivazSlice';
import {
 reportsGenerateFailure,
 reportsGenerateSuccess,
} from '../reports/reportsSlice';
import {
 getTableFailure as destPointGetTableFailure,
 createItemSuccess as destPointCreateItemSuccess,
 createItemFailure as destPointCreateItemFailure,
 updateItemSuccess as destPointUpdateItemSuccess,
 updateItemFailure as destPointUpdateItemFailure,
 deleteItemSuccess as destPointDeleteItemSuccess,
 deleteItemFailure as destPointDeleteItemFailure,
} from '../destPoint/destPointSlice';
import {
 getTableFailure as vehiclesGetTableFailure,
 createItemSuccess as vehiclesCreateItemSuccess,
 createItemFailure as vehiclesCreateItemFailure,
 updateItemSuccess as vehiclesUpdateItemSuccess,
 updateItemFailure as vehiclesUpdateItemFailure,
 deleteItemSuccess as vehiclesDeleteItemSuccess,
 deleteItemFailure as vehiclesDeleteItemFailure,
} from '../vehicles/vehiclesSlice';
import {
 getTableFailure as productsGetTableFailure,
 createItemSuccess as productsCreateItemSuccess,
 createItemFailure as productsCreateItemFailure,
 updateItemSuccess as productsUpdateItemSuccess,
 updateItemFailure as productsUpdateItemFailure,
 deleteItemSuccess as productsDeleteItemSuccess,
 deleteItemFailure as productsDeleteItemFailure,
} from '../products/productsSlice';
import {
 getTableFailure as driversGetTableFailure,
 createItemSuccess as driversCreateItemSuccess,
 createItemFailure as driversCreateItemFailure,
 updateItemSuccess as driversUpdateItemSuccess,
 updateItemFailure as driversUpdateItemFailure,
 deleteItemSuccess as driversDeleteItemSuccess,
 deleteItemFailure as driversDeleteItemFailure,
} from '../drivers/driversSlice';
import {
 getTableFailure as customersGetTableFailure,
 createItemSuccess as customersCreateItemSuccess,
 createItemFailure as customersCreateItemFailure,
 updateItemSuccess as customersUpdateItemSuccess,
 updateItemFailure as customersUpdateItemFailure,
 deleteItemSuccess as customersDeleteItemSuccess,
 deleteItemFailure as customersDeleteItemFailure,
} from '../customers/customersSlice';
import {
 getTableFailure as tableGetTableFailure,
 createItemSuccess as tableCreateItemSuccess,
 createItemFailure as tableCreateItemFailure,
 updateItemSuccess as tableUpdateItemSuccess,
 updateItemFailure as tableUpdateItemFailure,
 deleteItemSuccess as tableDeleteItemSuccess,
 deleteItemFailure as tableDeleteItemFailure,
} from '../table/tableSlice';

export const watchList = [
 // settings
 settingsGetTableFailure,
 settingsCreateItemSuccess,
 settingsCreateItemFailure,
 settingsUpdateItemSuccess,
 settingsUpdateItemFailure,
 settingsDeleteItemSuccess,
 settingsDeleteItemFailure,
 // weightings
 weightingsGetTableFailure,
 weightingsCreateItemSuccess,
 weightingsCreateItemFailure,
 weightingsUpdateItemSuccess,
 weightingsUpdateItemFailure,
 weightingsDeleteItemSuccess,
 weightingsDeleteItemFailure,
 // results
 resultsGetTableFailure,
 resultsCreateItemSuccess,
 resultsCreateItemFailure,
 resultsUpdateItemSuccess,
 resultsUpdateItemFailure,
 resultsDeleteItemSuccess,
 resultsDeleteItemFailure,
 approveResultSuccess,
 approveResultFailure,
 // destPoint
 destPointGetTableFailure,
 destPointCreateItemSuccess,
 destPointCreateItemFailure,
 destPointUpdateItemSuccess,
 destPointUpdateItemFailure,
 destPointDeleteItemSuccess,
 destPointDeleteItemFailure,
 // vehicles
 vehiclesGetTableFailure,
 vehiclesCreateItemSuccess,
 vehiclesCreateItemFailure,
 vehiclesUpdateItemSuccess,
 vehiclesUpdateItemFailure,
 vehiclesDeleteItemSuccess,
 vehiclesDeleteItemFailure,
 // products
 productsGetTableFailure,
 productsCreateItemSuccess,
 productsCreateItemFailure,
 productsUpdateItemSuccess,
 productsUpdateItemFailure,
 productsDeleteItemSuccess,
 productsDeleteItemFailure,
 // drivers
 driversGetTableFailure,
 driversCreateItemSuccess,
 driversCreateItemFailure,
 driversUpdateItemSuccess,
 driversUpdateItemFailure,
 driversDeleteItemSuccess,
 driversDeleteItemFailure,
 // customers
 customersGetTableFailure,
 customersCreateItemSuccess,
 customersCreateItemFailure,
 customersUpdateItemSuccess,
 customersUpdateItemFailure,
 customersDeleteItemSuccess,
 customersDeleteItemFailure,
 // identity
 identityLoginFailure,
 // clientConfiguration
 getClientConfigurationsSuccess,
 getClientConfigurationsFailure,
 // reports
 reportsGenerateSuccess,
 reportsGenerateFailure,
 // ivaz
 sendIVAZSuccess,
 sendIVAZFailure,
 // table
 tableGetTableFailure,
 tableCreateItemSuccess,
 tableCreateItemFailure,
 tableUpdateItemSuccess,
 tableUpdateItemFailure,
 tableDeleteItemSuccess,
 tableDeleteItemFailure,
];
